var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTreeViewItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 16,
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#797F89",
  fillRule: "evenodd",
  d: "m3.125 7.059.87-.934L7.5 9.883l3.504-3.758.871.934L7.5 11.75 3.125 7.059Z",
  clipRule: "evenodd"
})));
export { SvgIcTreeViewItem as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjEyNSA3LjA1ODUzTDMuOTk1NTYgNi4xMjVMNy41IDkuODgyOTNMMTEuMDA0NCA2LjEyNUwxMS44NzUgNy4wNTg1M0w3LjUgMTEuNzVMMy4xMjUgNy4wNTg1M1oiIGZpbGw9IiM3OTdGODkiLz4KPC9zdmc+Cg==";